import { store } from '@betacrew/jars-flux'
export const componentKey = "FORMS/BATCH_IMPORT";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        updateBatchImportFormData: (state, action) => {
            state.batchImportFormData = { ...state.batchImportFormData, ...action.payload };
        },
        setFormsList: (state, action) => {
            state.formsList = action.payload;
        },
        setIsYearFormTypeSelected: (state, action) => {
            state.isYearFormTypeSelected = action.payload;
        },
        setFormFields: (state, action) => {
            state.formFields = action.payload;
        },
        setExcelFields: (state, action) => {
            state.excelFields = action.payload;
        },
        setDraggableFormBoxes: (state, action) => {
            state.draggableFormBoxes = action.payload;
        },
        setMappedFields: (state, action) => {
            state.mappedFields = action.payload;
        },
        resetFieldsData: (state, action) => {
            state.formFields = [];
            state.excelFields = [];
            state.draggableFormBoxes = [];
            state.mappedFields = [];
        },
        setIsStateFilingApplicable: (state, action) => {
            state.isStateFilingApplicable = action.payload;
        },
        setFormSettings: (state, action) => {
            state.formSettings = action.payload;
        }, 
        setIsQuarterSelectionPopupOpen: (state, action) => {
            state.isQuarterSelectionPopupOpen = action.payload;
        }, 
        setQuarterSelectionPopupTriggeredByModule: (state, action) => {
            state.quarterSelectionPopupTriggeredByModule = action.payload;
        }, 
        setUploadFileLoadingState: (state, action) =>{
            state.uploadFileLoadingState = action.payload;
        },
    }, 
    initialReducerState: {
        loadingState: false,
        uploadFileLoadingState: false,
        batchImportFormData: {
            selectedYear: null,
            selectedForm: null,
            uploadedFile: null,
            filingForCorrected: false,
            isPreviousSavedData: null,
            goToListingStep: null,
            useUploadedFile: null,
            isUploadedDataSessionSet: null,
            pastedFileData: "",
            quarter: null,
        },
        isStateFilingApplicable: false,
        formsList: {},
        isYearFormTypeSelected: false,
        formFields: [],
        excelFields: [],
        draggableFormBoxes: [],
        mappedFields: [],
        formSettings: null,
        isQuarterSelectionPopupOpen: false,
        quarterSelectionPopupTriggeredByModule: null,
    }
});
export const {
    setLoadingState,
    setUploadFileLoadingState,
    updateBatchImportFormData,
    setFormsList,
    setIsYearFormTypeSelected,
    setFormFields,
    setExcelFields,
    setDraggableFormBoxes,
    setMappedFields,
    resetFieldsData,
    setIsStateFilingApplicable,
    setFormSettings,
    setIsQuarterSelectionPopupOpen,
    setQuarterSelectionPopupTriggeredByModule,
} = actions;